import { client, gql } from 'data-provider';
import { IPointOfContact } from 'interfaces';
import { capitalize } from 'utilities/shared';

export const getAllPointOfContacts = async (resource: string, resourceId: string) => {
  const capitalizedResource = capitalize(resource);
  const key = `${capitalizedResource}PointOfContacts`;

  const query = gql`
    query ($id: ID!) {
      ${key}(where: { ${resource}: $id }) {
        id
        name
        email
        designation
        mobileNumber
      }
    }
  `;

  const variables = { id: resourceId };
  const data = await client.request(query, variables);
  return data[key] as IPointOfContact[];
};

export const createPointOfContact = async (resource: string, data: Omit<IPointOfContact, 'id'>) => {
  const capitalizedResource = capitalize(resource);

  const createPointOfContact = gql`
    mutation ($input: create${capitalizedResource}PointOfContactInput) {
      create${capitalizedResource}POC(input: $input) {
        id
        name
        email
        designation
        mobileNumber
      }
    }
  `;

  const variables = { input: { data } };
  const createdData = await client.request(createPointOfContact, variables);
  return createdData;
};

export const updatePointOfContact = async (
  resource: string,
  resourceId: string,
  data: Omit<IPointOfContact, 'id'>
) => {
  const capitalizedResource = capitalize(resource);

  const updatePointOfContact = gql`
    mutation ($input: update${capitalizedResource}PointOfContactInput) {
      update${capitalizedResource}POC(input: $input) {
        ${resource}POC {
          id
        }
      }
    }
  `;

  const variables = {
    input: {
      where: { id: resourceId },
      data,
    },
  };

  const updatedData = await client.request(updatePointOfContact, variables);
  return updatedData;
};

export const getPOCOfSupplier = async (supplierId: string) => {
  const query = gql`
    query ($id: ID!) {
      supplier(id: $id) {
        pointOfContacts {
          id
          name
        }
      }
    }
  `;

  const variables = { id: supplierId };

  const data = await client.request(query, variables);
  return data.supplier.pointOfContacts as { id: string; name: string }[];
};

export const getPOCOfClient = async (clientId: string) => {
  const query = gql`
    query ($id: ID!) {
      client(id: $id) {
        pointOfContacts {
          id
          name
        }
      }
    }
  `;

  const variables = { id: clientId };

  const data = await client.request(query, variables);
  return data.client.pointOfContacts as { id: string; name: string }[];
};
